import type * as HotelApplicationDataRepository from "@/components/features/_shared/repository/hotel-application-data";
import type * as FormModelType from "@/components/features/cancellation/model/type";

export const serverModelToInputModelConverter = (
	serverModel: HotelApplicationDataRepository.Query.ServerModel,
): FormModelType.CancellationFormModel["InputModel"] => {
	return {
		hotelID: serverModel.hotelApplicationData.billingStatus.hotelID,
		churnInfo: {
			comment: null,
			reason: "",
		},
		defaultBasicBillingTicketID: null,
		defaultProBillingTicketID: null,
		isStopRecurringBasicBilling: true,
		isStopRecurringProBilling: true,
	};
};
